<div>
  @switch (paramValue) {
    @case (403) {
      <div>
        <error-forbidden></error-forbidden>
      </div>
    }
    @case (401) {
      <div>
        <error-notauthorized></error-notauthorized>
      </div>
    }
    @case ('offline') {
      <div>
        <error-network></error-network>
      </div>
    }
    @default {
      <div>
        <error-pagenotfound></error-pagenotfound>
      </div>
    }
  }
</div>